import React from 'react'
import classnames from 'classnames'
import { lossWhenPositive, warningWhenPositive } from '../cellColor'
import NullDash from './NullDash'

export type KwhCellRole = 'loss' | 'warning'

export interface KwhCellProps {
  value: number | null | undefined
  className?: string
  /** Semantic coloring; overridden by explicit valueClassName. */
  role?: KwhCellRole
  /** Optional class for the numeric portion (the unit stays muted). */
  valueClassName?: string
}

const roleColorClass = (role: KwhCellRole | undefined, value: number): string | undefined => {
  if (role === 'loss') return lossWhenPositive(value)
  if (role === 'warning') return warningWhenPositive(value)
  return undefined
}

/** Table-friendly kWh: nowrap, tabular number, smaller muted unit suffix. */
export const KwhCell: React.FC<KwhCellProps> = ({ value, className, role, valueClassName }) => {
  if (value == null || Number.isNaN(value)) {
    return <NullDash className={className} />
  }
  const colorClass = classnames(roleColorClass(role, value), valueClassName)
  return (
    <span className={classnames('whitespace-nowrap tabular-nums', className)}>
      <span className={colorClass}>{Math.round(value).toLocaleString()}</span>
      <span className="ml-1 text-xs font-normal text-slate-400 dark:text-slate-400">kWh</span>
    </span>
  )
}

export default KwhCell
